document.addEventListener("turbo:load", function () {
  setupContractNoteListeners();
  restoreDropdownSelections();
  clearLocalStorageOnModalOpen();
  alertForLastBill();
  allBillFilters();
});

function allBillFilters() { 
  const itemSelect = document.getElementById("item-filter-select");
  const form = document.getElementById("item-filter-form");
  const inputSearch = document.getElementById("bill-search-input");
  const dateInput = document.getElementById("bill_date");
  const hiddenInput = document.getElementById("selected-bill-ids");

  if (itemSelect && form) {
    itemSelect.addEventListener("change", function() {
      form.requestSubmit();
    });
  }

  if (inputSearch || form) {
    if (inputSearch.value.trim() !== "") {
      inputSearch.focus();
      inputSearch.setSelectionRange(inputSearch.value.length, inputSearch.value.length);
    }

    let timeout = null;

    inputSearch.addEventListener("input", function() {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        form.requestSubmit();
      }, 1300);
    });
  }

  if (dateInput && form) {
    dateInput.addEventListener("change", function() {
      form.requestSubmit();
    });
  }

  if (form && hiddenInput) {
    form.addEventListener("submit", function (e) {
      const submitter = e.submitter;
      if (submitter && submitter.textContent.trim() === "Remove Bills") {
        const selected = Array.from(document.querySelectorAll(".bill-checkbox:checked")).map(cb => cb.value);
        if (selected.length === 0) {
          e.preventDefault();
          alert("Please select at least one bill to remove.");
          return;
        }
        hiddenInput.value = selected.join(",");
      }
    });
  }
}

// Save dropdown selections when changed
function setupContractNoteListeners() {
  const sellerSelect = document.getElementById("seller_select");
  const buyerSelect = document.getElementById("buyer_select"); // may be null in unloading
  const financerSelect = document.getElementById("financer_select");
  const infoDiv = document.getElementById("contract-note-info");

  if (!sellerSelect || !financerSelect || !infoDiv) return;

  const context = document.getElementById("billModal")?.dataset?.context || "new_bill";
  const selects = [sellerSelect, financerSelect, buyerSelect];
  if (context === "new_bill" && buyerSelect) selects.push(buyerSelect);

  selects.forEach(select => {
    select.addEventListener("change", function () {
      localStorage.setItem(select.id, select.value);
      fetchBillInfo();
    });
  });

  function fetchBillInfo() {
    const params = new URLSearchParams();

    if (sellerSelect.value) params.append("seller_id", sellerSelect.value);
    if (buyerSelect?.value) params.append("buyer_id", buyerSelect.value);
    if (financerSelect.value) params.append("financer_id", financerSelect.value);

    if (params.toString() === "") {
      infoDiv.innerHTML = "";
      return;
    }

    let url;
    if (context === "unloading") {
      url = `/broker/filter_unloading_entries?${params}`;
    } else {
      url = `/broker/contract_notes/show_details?${params}`;
    }

    fetch(url)
      .then(response => response.json())
      
      .then(data => {
        if (data.length === 0) {
          infoDiv.innerHTML = "<p class='text-danger'>Record not found</p>";
        } else {
          if (context === "unloading") {
            const html = data.map(bill => `
              <div class="contract-note">
                <h5>Vehicle No: ${bill.vehicle_no || "N/A"}</h5>
                <h5>Bill No: ${bill.bill_no || "N/A"}</h5>
                <h5>Seller: ${bill.seller_name || "N/A"}</h5>
                <h5>Financer: ${bill.financer_name || "N/A"}</h5>
                <div class="mb-2">
                  <a class="btn btn-sm btn-secondary" href="/broker/contract_notes/${bill.contract_note_id}/bills/${bill.id}/edit?return_to=${encodeURIComponent(window.location.pathname)}&unloading=true">
                    Update Unloading
                  </a>
                </div>
              </div>
            `).join('');
            infoDiv.innerHTML = html;
          } else {
            const html = data
              .filter(note => {
                const noFinancer = !note.financer_name;
                const sellerPresent = !!note.seller_name;
                const sellerBillCompleted = note.seller_last_bill;
            
                // If there's no financer, seller is present, and seller bill is completed => skip this record
                return !(noFinancer && sellerPresent && sellerBillCompleted);
              })
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map(note => {
                const formattedDate = note.date
                  ? new Date(note.date).toLocaleDateString('en-GB')
                  : "N/A";
              const hasFinancer = !!note.financer_name;
            
              const sellerButton = note.seller_last_bill
                ? `<button class="btn btn-success" disabled>Seller Bill Completed</button>`
                : `<a class="btn btn-primary" href="/broker/contract_notes/${note.id}/bills/new?type=seller">Generate Seller Bill</a>`;
            
              const financerButton = hasFinancer
                ? (note.financer_last_bill
                  ? `<button class="btn btn-success me-2" disabled>Financer Bill Completed</button>`
                  : `<a class="btn btn-primary me-2" href="/broker/contract_notes/${note.id}/bills/new?type=financer">Generate Financer Bill</a>`)
                : `<button class="btn btn-danger me-2" disabled>No Financer Available</button>`;
            
              const unitMap = {
                  0: 'MT',
                  1: 'TRUCK(S)'
                };

              return `
                <div class="contract-note">
                  <h5><strong>Date: ${formattedDate} (${note.item_name})</strong></h5>
                  <h5>Contract No: ${note.contract_no || "N/A"}</h5>
                  <h5>Delivery Place: ${note.delivery_place || "N/A"}</h5>
                  <h5><strong>Remaining Quantity for Seller Bill:</strong> ${note.seller_remaining_weight ?? "N/A"} ${unitMap[note.quantity_unit]}</h5>
                  ${hasFinancer ? `<h5><strong>Remaining Quantity for Financer Bill:</strong> ${note.financer_remaining_weight ?? "N/A"} ${unitMap[note.quantity_unit]}</h5>` : ""}
                  <h5>Buyer: ${note.buyer_name || "N/A"}</h5>
                  <h5>Seller: ${note.seller_name || "N/A"} 
                    <span><strong>(Rate: ₹${note.seller_rate || "N/A"})</strong></span></h5>
                  <h5>Financer: ${hasFinancer ? note.financer_name : "N/A"}
                    <span><strong>(Rate: ₹${note.financer_rate || "N/A"})</strong></span></h5>
                  <div class="mt-1">
                    ${financerButton}
                    ${sellerButton}
                  </div>
                  <br>
                </div>
              `;
            }).join('');
            infoDiv.innerHTML = html;
          }
        }
      });
  }
}

function restoreDropdownSelections() {
  ["buyer_select", "seller_select", "financer_select"].forEach(id => {
    const el = document.getElementById(id);
    const savedValue = localStorage.getItem(id);
    if (el && savedValue) {
      el.value = savedValue;
    }
  });

  const context = document.getElementById("billModal")?.dataset?.context || "new_bill";
  const buyer = document.getElementById("buyer_select");
  const seller = document.getElementById("seller_select");
  const financer = document.getElementById("financer_select");

  setTimeout(() => {
    if (context === "new_bill") {
      buyer.dispatchEvent(new Event("change"));
    } else if (context === "unloading") {
      // Trigger change on seller/financer for unloading
      if (seller?.value) seller.dispatchEvent(new Event("change"));
      else if (financer?.value) financer.dispatchEvent(new Event("change"));
    }
  }, 200);
}


function clearLocalStorageOnModalOpen() {
  const billModalButton = document.querySelector(".btn.btn-primary[data-bs-toggle='modal'][data-bs-target='#billModal']");
  
  if (billModalButton) {
    billModalButton.addEventListener("click", function () {
      // Clear saved dropdown selections from localStorage
      ["buyer_select", "seller_select", "financer_select"].forEach(id => {
        localStorage.removeItem(id);
      });
      console.log("LocalStorage cleared");
    });
  }
}

function alertForLastBill() {
  const checkbox = document.getElementById("last_bill_checkbox");

  if (checkbox) {
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        const isConfirmed = confirm("Are you sure this is your last bill?");
        if (!isConfirmed) {
          checkbox.checked = false;
        }
      }
    });
  }
}
